import React from 'react'
const AuthResetPassword = ({ bg, className }) => {
  return (
    <div
      className={`md:flex hidden justify-start items-end pl-[58px] pr-[24px] pb-[44px] w-[50%] h-auto login-banner-bg ${
        bg ? "bg-[url('../../assets/images/bg-set-reset-img.png')]" : className
      }`}
    >
      <div>{/* <img src={CompanyLogo} alt="Company logo" /> */}</div>
      <div className="max-w-[427px]">
        <h2 className="text-2xl font-semibold text-[#E9DFFF] mb-[9px]">
          Hematogenix's mission
        </h2>
        <p className="max-w-[380px] w-full font-normal text-sm text-[#E9DFFF] m-0">
          Our mission is to assist pharma companies bring novel treatments from
          bench to bedside.
        </p>
      </div>
    </div>
  )
}

export default AuthResetPassword
